
import { Suspense } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import BlogHero from './components/BlogHero';
import BlogGrid from './components/BlogGrid';
import { useSEO } from '../../utils/seo';

const BlogPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Sigorta Dijital Akademi - Blog | Sigorta360',
    description: 'Sigorta acenteleri için dijital pazarlama, sosyal medya, CRM ve teknoloji konularında güncel içerikler. Sektöre özel ipuçları ve stratejiler.',
    keywords: 'sigorta blog, sigorta dijital pazarlama, sigorta sosyal medya ipuçları, sigorta CRM, sigorta teknoloji',
    canonical: `${siteUrl}/sigorta-dijital-akademi`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Blog',
      name: 'Sigorta Dijital Akademi',
      description: 'Sigorta acenteleri için dijital pazarlama ve teknoloji blogu',
      url: `${siteUrl}/sigorta-dijital-akademi`,
      publisher: {
        '@type': 'Organization',
        name: 'Sigorta360',
        url: siteUrl
      }
    }
  });

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="min-h-screen bg-white">
        <Header />
        <BlogHero />
        <BlogGrid />
        <Footer />
      </div>
    </Suspense>
  );
};

export default BlogPage;
